var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.512,
    height: 12.276,
    viewBox: "0 0 12.512 12.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2234",
    "data-name": "Rectangle 2234",
    width: 12.512,
    height: 12.276,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10210",
    "data-name": "Group 10210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10209",
    "data-name": "Group 10209",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27575",
    "data-name": "Path 27575",
    d: "M3.053.165a.579.579,0,0,0-.808,0L.158,2.253a.578.578,0,0,0,.006.8.578.578,0,0,0,.8.006L2.08,1.944v9.762a.569.569,0,1,0,1.139,0V1.944L4.333,3.06a.579.579,0,0,0,.4.165.569.569,0,0,0,.4-.973Z",
    transform: "translate(0 0.001)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27576",
    "data-name": "Path 27576",
    d: "M9.886,9.222a.578.578,0,0,0-.8-.006L7.97,10.332V.569a.569.569,0,1,0-1.139,0v9.762L5.717,9.216a.578.578,0,0,0-.8.006.572.572,0,0,0-.006.8L7,12.111a.568.568,0,0,0,.4.165.579.579,0,0,0,.4-.165l2.088-2.088a.578.578,0,0,0-.006-.8",
    transform: "translate(2.461 0)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon12);
export default __webpack_public_path__ + "static/media/social-icon12.81a7c68278d33ad4009eab212abb0be9.svg";
export { ForwardRef as ReactComponent };